//Cores
export const azulBg = '#EAF2FD';
export const azulConteudo = '#2A7AE4';
export const preto = '#464646';
export const cinza = " #F5F5F5;";
export const cinzaBg = "#e5e5e5";
export const cinzaInput ="#a2a2a2";
export const branco = "#ffffff";

